<template>
  <licence-editor

    ref="customLicenceForm"
    :open="newLicenceDialog"
    :editing="false"
    :licence="newLicencePayload"
    :features="featuresPayload"
    :definitions="features"
    :parents="parentLicences"
    :selected-scopes.sync="selectedScopes"
    :loading="loading"
    :loading-parents="loadingParents"
    :loading-features="loadingFeatures"
    :feature-error="featureError"
    @retry-features="initialize"
    @close="closeCustomLicenceDialog"
    @save="createNewLicence"
  />
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
import LicenceEditor from './LicenceEditor.vue'

export default {
  components: { LicenceEditor },
  props: {
    newLicence: { type: Boolean, default: false },
    newLicenceDialog: { type: Boolean, default: false }
  },
  created () {
    this.initialize()
    this.loadParentLicences()
  },
  data: () => ({
    selectedScopes: [],
    loading: false,
    loadingFeatures: true,
    featureError: false,
    loadingParents: false,
    parentLicences: [],

    newLicencePayload: { licence_name: '', price_monthly: '', price_yearly: '', parent_id: null },
    featuresPayload: [],
    features: []

  }),
  methods: {
    async initialize () {
      this.loadingFeatures = true
      this.featureError = false
      await apiService.get('admin-get-features')
        .then((res) => {
          this.featuresPayload = []
          this.features = res.data.data
          for (let i = 0; i < this.features.length; i++) {
            this.featuresPayload.push({ feature_id: this.features[i].feature_id, limit: '' })
          }
        })
        .catch(() => { this.featureError = true })
        .finally(() => { this.loadingFeatures = false })
    },
    async createNewLicence () {
      const payload = {
        licence_name: this.newLicencePayload.licence_name,
        price_monthly: this.newLicencePayload.price_monthly,
        price_yearly: this.newLicencePayload.price_yearly,
        features: this.featuresPayload,
        scopes: this.selectedScopes,
        parent_id: this.newLicencePayload.parent_id || null
      }
      if (!this.loading && this.$refs.customLicenceForm.validate()) {
        this.loading = true
        await apiService.post('admin-create-licence', payload)
          .then(() => {
            this.closeCustomLicenceDialog()
            this.$emit('getAllLicences')
            Swal.fire('Created!', 'Licence created successfully!', 'success')
          })
          .catch((err) => {
            const errMsg = err.response?.data?.message || 'An error occurred while creating the license!'
            Swal.fire('Error!', errMsg, 'error')
          })
          .finally(() => { this.loading = false })
      }
    },
    async loadParentLicences () {
      this.loadingParents = true
      try {
        const { data } = await apiService.get('admin-parent-licences')
        this.parentLicences = (data.data || []).filter((p) => p.is_active)
      } catch (err) {
        console.error('Error loading parent licences:', err)
      } finally {
        this.loadingParents = false
      }
    },
    closeCustomLicenceDialog () {
      this.$emit('closeNewLicenceDialog')
    }
  }
}
</script>
